import {useUserTranslations} from 'Event/LanguageProvider/translations'
import HTMLEditor, {HTMLEditorContainer} from 'lib/ui/form/HTMLEditor'
import {defaultToolbar} from 'lib/ui/form/HTMLEditor/toolbar'
import {
  EMAIL,
  EVENT_NAME,
  FIRST_NAME,
  LAST_NAME,
  TIME,
  TODAY,
} from 'lib/ui/form/HTMLEditor/variables'
import {Label} from 'lib/ui/typography'
import {Question} from 'organization/Event/QuestionsProvider'
import React from 'react'
import {Controller, UseFormMethods} from 'react-hook-form'
import styled from 'styled-components'

export default function ContentInput(props: {
  question?: Question
  control: UseFormMethods['control']
  error?: string
}) {
  const {question, control, error} = props
  const v = useUserTranslations()

  return (
    <>
      <Label>Content</Label>
      <HTMLEditorContainer>
        <Controller
          name="label"
          defaultValue={v(question?.label || '')}
          control={control}
          rules={{
            validate: (html: string) =>
              hasContent(html) || 'Content is required',
          }}
          render={({onChange, value}) => (
            <HTMLEditor
              data={value}
              onChange={onChange}
              toolbar={[...defaultToolbar, 'obvioVariable']}
              variables={[
                FIRST_NAME,
                LAST_NAME,
                EMAIL,
                EVENT_NAME,
                TODAY,
                TIME,
              ]}
            />
          )}
        />
      </HTMLEditorContainer>
      {error && <ErrorText>{error}</ErrorText>}
    </>
  )
}

function hasContent(html: string) {
  const withoutEmptyParagraphs = html.replace(
    /<p[^>]*>(\s|&nbsp;|<br\s*\/?>)*<\/p>/g,
    '',
  )

  return withoutEmptyParagraphs.trim() !== ''
}

const ErrorText = styled.p`
  color: ${(props) => props.theme.colors.error};
  margin-top: 0;
`
